import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { PagesComponent } from "./pages/pages.component";
import { AuthGuardHrUser } from "./core/auth/auth-guard-hruser.service";

import { AuthGuardCommon } from "./core/auth/auth-guard-common.service";

const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/home/home.module").then((m) => m.HomeModule),
      },
      {
        path: "affiliates",
        loadChildren: () =>
          import("./pages/affiliate/affiliate.module").then(
            (m) => m.AffilateModule
          ),
      },

      {
        path: "hr-login",
        loadChildren: () =>
          import("./pages/hr_login/hr_login.module").then(
            (m) => m.HrLoginModule
          ),
      },
      {
        path: "register",
        loadChildren: () =>
          import("./pages/hr_registration/hr_registration.module").then(
            (m) => m.HrRegistrationModule
          )
      },
      {
        path: "forgot",
        loadChildren: () =>
          import("./pages/hr_forgot/hr_forgot.module").then(
            (m) => m.HrForgotModule
          ),
      },
      {
        path: "promocode-offers",
        loadChildren: () =>
          import("./pages/promocode_offers/promocode_offers.module").then(
            (m) => m.PromocodeoffersModule
          ),
      },
      {
        path: "pricings",
        loadChildren: () =>
          import("./pages/pricing/pricing.module").then((m) => m.PricingModule),
      },
      {
        path: "device-pricing",
        loadChildren: () =>
          import("./pages/device_pricing/device_pricing.module").then(
            (m) => m.DevicePricingModule
          ),
      },
      {
        path: "device-pricing-details",
        loadChildren: () =>
          import(
            "./pages/device_pricingdetails/device_pricingdetails.module"
          ).then((m) => m.DevicePricingdetailsModule),
      },
      {
        path: "human-resources-information-systems-hris",
        loadChildren: () =>
          import("./pages/hris/hris.module").then((m) => m.HrisBlogModule),
      },
      {
        path: "what-is-attendance-management",
        loadChildren: () =>
          import("./pages/attandance/attandance.module").then(
            (m) => m.AttandanceBlogModule
          ),
      },
      {
        path: "what-is-leave-management",
        loadChildren: () =>
          import("./pages/leave/leave.module").then((m) => m.LeaveBlogModule),
      },
      {
        path: "what-is-payroll",
        loadChildren: () =>
          import("./pages/payroll/payroll.module").then(
            (m) => m.PayrollBlogModule
          ),
      },

      

      //////////////////////////////////// Our Features //////////////////////////////////////////////

      {
        path: "hr-management-software",
        loadChildren: () =>
          import("./pages/Hr-mngt-software/Hr-mngt-software.module").then(
            (m) => m.HrSoftwareModule
          ),
      },
      {
        path: "employee-self-service",
        loadChildren: () =>
          import("./pages/Emp-self-service/emp-self-service.module").then(
            (m) => m.EmpSelfServiceModule
          ),
      },
      {
        path: "employee-management-software",
        loadChildren: () =>
          import("./pages/Emp-mngt-software/Emp-mngt-software.module").then(
            (m) => m.EmpManagementModule
          ),
      },
      {
        path: "payroll-management-software",
        loadChildren: () =>
          import(
            "./pages/payroll-mngt-software/payroll-mngt-software.module"
          ).then((m) => m.PayrollManagementModule),
      },
      {
        path: "leave-management-software",
        loadChildren: () =>
          import("./pages/leave-mngt-software/leave-mngt-software.module").then(
            (m) => m.LeaveManagementModule
          ),
      },
      {
        path: "attendance-management-software",
        loadChildren: () =>
          import(
            "./pages/attendance-mngt-software/attendance-mngt-software.module"
          ).then((m) => m.AttendanceManagementModule),
      },
      {
        path: "candidate-management-software",
        loadChildren: () =>
          import(
            "./pages/candidate-mngt-software/candidate-mngt-software.module"
          ).then((m) => m.CandidateManagementModule),
      },
      {
        path: "biometric-attendance",
        loadChildren: () =>
          import(
            "./pages/biometric-attendance/biometric-attendance.module"
          ).then((m) => m.BiometricAttendanceModule),
      },
      {
        path: "salary-slip",
        loadChildren: () =>
          import("./pages/salary-slip/salary-slip.module").then(
            (m) => m.SalarySlipModule
          ),
      },
      {
        path: "about-hrmking",
        loadChildren: () =>
          import("./pages/about-hrmking/about-hrmking.module").then(
            (m) => m.AboutHrmkingModule
          ),
      },
      {
        path: "our-partners",
        loadChildren: () =>
          import("./pages/our-partners/our-partners.module").then(
            (m) => m.OurPartnersModule
          ),
      },
      {
        path: "our-teams",
        loadChildren: () =>
          import("./pages/our-teams/our-teams.module").then(
            (m) => m.OurTeamsModule
          ),
      },
      {
        path: "our-clients",
        loadChildren: () =>
          import("./pages/our-clients/our-clients.module").then(
            (m) => m.OurClientsModule
          ),
      },
      {
        path: "blogssssss",
        loadChildren: () =>
          import("./pages/blog/blog.module").then((m) => m.BlogModule),
      },

      {
        path: "employee-form/:adminId",
        loadChildren: () =>
          import("./pages/employee-form/employee-form.module").then(
            (m) => m.EmployeeFormModule
          ),
      },
      {
        path: "job-opening",
        loadChildren: () =>
          import("./pages/job-opening/job-opening.module").then(
            (m) => m.JobOpeningModule
          ),
      },
      {
        path: "job-opening/:adminId",
        loadChildren: () =>
          import("./pages/job-opening/job-opening.module").then(
            (m) => m.JobOpeningModule
          ),
      },
      {
        path: "apply-job",
        loadChildren: () =>
          import("./pages/apply-job/apply-job.module").then(
            (m) => m.ApplyJobModule
          ),
      },
      {
        path: "apply-job/:jobId",
        loadChildren: () =>
          import("./pages/apply-job/apply-job.module").then(
            (m) => m.ApplyJobModule
          ),
      },
      {
        path: "apply-job/:jobId/:adminId",
        loadChildren: () =>
          import("./pages/apply-job/apply-job.module").then(
            (m) => m.ApplyJobModule
          ),
      },

      //////////////////////////////////// Close Our Features //////////////////////////////

      {
        path: "devices-checkout",
        loadChildren: () =>
          import("./pages/device_checkout/device_checkout.module").then(
            (m) => m.DeviceCheckoutModule
          ),
      },
      {
        path: "products",
        loadChildren: () =>
          import("./pages/products/products.module").then(
            (m) => m.ProductModule
          ), canActivate: [AuthGuardHrUser],
      },
      {
        path: "thankyou",
        loadChildren: () =>
          import("./pages/thankyou/thankyou.module").then(
            (m) => m.ThankyouModule
          ),
      },
      {
        path: "renew-packages",
        loadChildren: () =>
          import("./pages/renew_packages/renew_packages.module").then(
            (m) => m.RenewPackageModule
          ), canActivate: [AuthGuardHrUser],
      },
      {
        path: "package-invoices",
        loadChildren: () =>
          import("./pages/package_invoice/package_invoice.module").then(
            (m) => m.PackageInvoicesModule
          ), canActivate: [AuthGuardHrUser],
      },
      {
        path: "device-invoices",
        loadChildren: () =>
          import("./pages/device_invoice/device_invoice.module").then(
            (m) => m.DeviceInvoicesModule
          ), canActivate: [AuthGuardHrUser],
      },
      {
        path: "profiles",
        loadChildren: () =>
          import("./pages/profile/profile.module").then((m) => m.ProfileModule), canActivate: [AuthGuardHrUser],
      },
      {
        path: "login",
        loadChildren: () =>
          import("./pages/login/login.module").then((m) => m.LoginModule),
      },
      {
        path: "user-login",
        loadChildren: () =>
          import("./pages/user-login/user-login.module").then(
            (m) => m.UserLoginModule
          ),
      },

      ///////////////y///////////////PrivacyPolicyModule///////////////////////

      {
        path: "privacy-policy",
        loadChildren: () =>
          import("./pages/privacy-policy/privacy-policy.module").then(
            (m) => m.PrivacyPolicyModule
          ),
      },
      {
        path: "terms-and-conditions",
        loadChildren: () =>
          import("./pages/terms-and-condition/terms-and-condition.module").then(
            (m) => m.TermAndConditionModule
          ),
      },
      {
        path: "refund-policy",
        loadChildren: () =>
          import("./pages/refund-policy/refund-policy.module").then(
            (m) => m.RefundPolicyModule
          ),
      },
      {
        path: "contact-us",
        loadChildren: () =>
          import("./pages/contact-us/contact-us.module").then(
            (m) => m.ContactUsModule
          ),
      },
      {
        path: "about-us",
        loadChildren: () =>
          import("./pages/about-us/about-us.module").then(
            (m) => m.AboutUsModule
          ),
      },
      {
        path: "checkouts/:id",
        loadChildren: () =>
          import("./pages/checkout/checkout.module").then((m) => m.CheckoutModule),
      },
    ],
  },
  {
    path: "error",
    loadChildren: () =>
      import("./errorpages/errorpages.module").then((m) => m.ErrorpagesModule),
  },
  {
    path: "layout",
    loadChildren: () =>
      import("./all-modules/all-modules.module").then(
        (m) => m.AllModulesModule
      ), canActivate: [AuthGuardCommon],
  },
  
  { path: 'salary-settings', loadChildren: () => import('./all-modules/salary-settings/salary-settings.module').then(m => m.SalarySettingsModule) },
  
  // { path: 'all-modules/hr-admin', loadChildren: () => import('./all-modules/hr-admin/hr-admin.module').then(m => m.HrAdminModule) },

  { path: "**", redirectTo: "/error/error404" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
